module.exports = __webpack_public_path__ + "media/images/clickworker_com/f2a_step_1-dcfa8a4438c8196121d67b6f940d70f2.png";